import { Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Apollo } from 'apollo-angular';
import { Location } from '@angular/common';
import { firstValueFrom } from 'rxjs';
import { NotificationService } from '../../../../services/notification.service';
import { AppState } from '../../../../store';
import { PaymentPrintComponent } from '../../../billing-management/payment-list/payment-print/payment-print.component';
import { GET_ALL_PAYMENT_LIST } from '../../../billing-management/payment-list/payment.graphql';

@Component({
  selector: 'app-corporate-payment-view',
  templateUrl: './corporate-payment-view.component.html',
  styleUrl: './corporate-payment-view.component.scss',
  standalone:false,
})
export class CorporatePaymentViewComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private store = inject(Store<AppState>);
  private notify = inject(NotificationService);
  private apollo = inject(Apollo);
    private dialog = inject(MatDialog);
  
  location = inject(Location);

  payment: any = null;
  loading = true;
  today = new Date();

  ngOnInit(): void {
    const uuid = this.route.snapshot.paramMap.get('uuid');
    console.log('Route UUID:', uuid);
    
    if (!uuid) {
      this.notify.errorMessage('Invalid payment ID');
      this.loading = false;
      return;
    }
    this.fetchPayment(uuid);
  }

  async fetchPayment(uuid: string) {
    this.loading = true;
    try {
      const result = await firstValueFrom(
        this.apollo.query<any>({
          query: GET_ALL_PAYMENT_LIST,
          variables: { 
            filtering: { uuid },
            pageNumber: 0,
            itemsPerPage: 1
          },
          fetchPolicy: 'network-only',
        })
      );

      console.log('GraphQL Response:', result);

      // Access the correct nested data structure
      const paymentData = result.data?.getPaymentList?.data || [];
      console.log('Payment data array:', paymentData);

      // Find payment by UUID
      this.payment = paymentData.find((p: any) => p.uuid === uuid) || paymentData[0] || null;
      
      console.log('Found payment:', this.payment);

      if (!this.payment) {
        this.notify.errorMessage('Payment not found');
      }
    } catch (err) {
      console.error('Error fetching payment:', err);
      this.notify.errorMessage('Failed to load payment details');
    } finally {
      this.loading = false;
    }
  }

printBill(): void {
  if (!this.payment) {
    this.notify.errorMessage("No bill data to print");
    return;
  }

  // Open dialog and pass UUID
  this.dialog.open(PaymentPrintComponent, {
    width: "90vw",
    maxWidth: "1200px",
    height: "90vh",
    disableClose: false,
    data: {
      uuid: this.payment.uuid,
    },
  });
}

  // Format amount - handle both number and object with parsedValue
  formatAmount(amount?: number | { parsedValue: number; source: string }): string {
    if (!amount) return '—';
    
    // If amount is an object with parsedValue
    if (typeof amount === 'object' && 'parsedValue' in amount) {
      return `TZS ${amount.parsedValue.toLocaleString()}`;
    }
    
    // If amount is a number
    return `TZS ${amount.toLocaleString()}`;
  }

  // Format date
  formatDate(date?: string): string {
    if (!date) return '—';
    return new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  // Go back to list
  goBack(): void {
    this.location.back();
  }
}